<template>
  <div class="collapsible">
    <div class="header" @click="onOpen()">
      <slot name="header"></slot>
      <span v-if="chevron" class="chevron" :class="{ down: isOpen }">></span>
    </div>
    <transition name="slide">
      <div class="content" v-if="isOpen">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'collapsible',
  data () {
    return {
      open: false
    }
  },
  props: [ 'id', 'currentOpenId', 'chevron', 'forceOpen'],
  methods: {
    onOpen () {
      if (this.isOpen) {
        this.$emit('close', this.id);
      } else {
        this.$emit('open', this.id);
      }
      this.open = !this.open;
    }
  },
  computed: {
    isOpen () {
      if (this.forceOpen !== undefined) {
        return this.forceOpen;
      } else if (this.id) {
        return this.id === this.currentOpenId;
      } else {
        return this.open;
      }
    }
  }
}
</script>

<style scoped>

.collapsible {
  /* margin-bottom: 1em; */
}

.content {
  max-height: 250em;
  overflow: hidden;
}

.slide-enter-active {
  transition: max-height 0.8s ease-in,
              opacity 0.3s ease;
}
.slide-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: max-height 3.0s ease-out -2.5s,
              opacity 0.3s ease;
}

.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.chevron {
  font-size: 200%;
  font-weight: bold;
  position: absolute;
  top: 21%;
  right: 10%;
  transform: rotate(90deg);
  transition: all 0.3s ease;
}

.chevron.down {
  transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Collapsible.vue